import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-min-h-[calc(100vh-60px)] tw-bg-white tw-py-10" }
const _hoisted_2 = { class: "tw-mx-auto tw-w-full tw-max-w-7xl tw-px-6 lg:tw-px-8" }
const _hoisted_3 = { class: "tw-grid tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-3" }
const _hoisted_4 = { class: "tw-flex tw-items-start tw-justify-between tw-mb-4" }
const _hoisted_5 = { class: "tw-relative" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "tw-absolute tw-right-0 tw-z-10 tw-mt-2 tw-w-72 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-2 tw-shadow-xl tw-ring-1 tw-ring-black/5"
}
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "tw-min-w-0" }
const _hoisted_11 = { class: "tw-truncate tw-text-xs tw-font-medium tw-text-slate-700" }
const _hoisted_12 = { class: "tw-text-[10px] tw-text-slate-400" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "tw-px-3 tw-py-4 tw-text-center tw-text-xs tw-text-slate-400 italic"
}
const _hoisted_15 = { class: "tw-text-lg tw-font-bold tw-text-slate-900" }
const _hoisted_16 = { class: "tw-mt-2 tw-text-sm tw-leading-relaxed tw-text-slate-500 tw-flex-grow" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "tw-relative tw-flex tw-flex-col tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-6 tw-shadow-sm tw-transition-shadow hover:tw-shadow-md" }
const _hoisted_19 = { class: "tw-flex tw-items-start tw-justify-between tw-mb-4" }
const _hoisted_20 = { class: "tw-bg-orange-50 tw-text-orange-600 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-xl" }
const _hoisted_21 = { class: "tw-space-y-6" }
const _hoisted_22 = {
  key: 0,
  class: "tw-space-y-4"
}
const _hoisted_23 = { class: "tw-grid tw-grid-cols-2 tw-gap-4" }
const _hoisted_24 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_25 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_26 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_27 = {
  key: 1,
  class: "tw-space-y-4"
}
const _hoisted_28 = { class: "tw-grid tw-grid-cols-2 tw-gap-4" }
const _hoisted_29 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_30 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_31 = { class: "tw-grid tw-grid-cols-2 tw-gap-4" }
const _hoisted_32 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_33 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-rose-600"
}
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-cursor-pointer" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { class: "tw-border-t tw-border-slate-100 tw-pt-5" }
const _hoisted_41 = { class: "tw-grid tw-grid-cols-3 tw-gap-3" }
const _hoisted_42 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_DropdownList = _resolveComponent("DropdownList")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DocumentTemplateEditor = _resolveComponent("DocumentTemplateEditor")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "tw-mb-10" }, [
        _createElementVNode("h1", { class: "tw-text-2xl tw-font-bold tw-text-slate-900" }, "Reports & Analytics"),
        _createElementVNode("p", { class: "tw-mt-1 tw-text-sm tw-text-slate-500" }, " Generate insights on yard operations, inventory, and efficiency. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTypes, (type) => {
          return (_openBlock(), _createElementBlock("div", {
            key: type.id,
            class: "tw-relative tw-flex tw-flex-col tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-6 tw-shadow-sm tw-transition-shadow hover:tw-shadow-md"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass([type.iconBg, type.iconColor, 'tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-xl'])
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: type.icon,
                  class: "tw-h-5 tw-w-5"
                }, null, 8, ["icon"])
              ], 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _withModifiers(($event: any) => (_ctx.togglePastReports(type.id)), ["stop"]),
                  class: "tw-p-2 tw-text-slate-400 hover:tw-text-slate-600 tw-transition-colors"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "ellipsis-vertical" })
                ], 8, _hoisted_6),
                (_ctx.openPastReportsId === type.id)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_font_awesome_icon, { icon: "clock-rotate-left" }),
                        _cache[17] || (_cache[17] = _createTextVNode(" Past reports ", -1))
                      ]),
                      (type.pastReports && type.pastReports.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.pastReports, (report) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: report.id,
                                class: "tw-group tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-px-3 tw-py-2 hover:tw-bg-slate-50"
                              }, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(report.displayName), 1),
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(report.fileFormat) + " * Ready", 1)
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.downloadPastReport(report)),
                                  class: "tw-p-1 tw-text-slate-400 hover:tw-text-blue-600 tw-transition-colors"
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "download",
                                    class: "tw-h-3.5 tw-w-3.5"
                                  })
                                ], 8, _hoisted_13)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, " No recent reports "))
                    ])), [
                      [_directive_click_outside, () => _ctx.openPastReportsId = null]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("h3", _hoisted_15, _toDisplayString(type.name), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(type.description), 1),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.openReportGenerator(type.id)),
              class: "tw-mt-6 tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-bg-slate-50 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-transition hover:tw-bg-slate-100"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "chart-simple",
                class: "tw-h-3.5 tw-w-3.5"
              }),
              _createTextVNode(" " + _toDisplayString(type.id === 'DOC_BUILDER' ? 'Manage Templates' : 'Generate Report'), 1)
            ], 8, _hoisted_17)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_font_awesome_icon, {
                icon: "file-signature",
                class: "tw-h-5 tw-w-5"
              })
            ])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "tw-text-lg tw-font-bold tw-text-slate-900" }, "Document Templates", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "tw-mt-2 tw-text-sm tw-leading-relaxed tw-text-slate-500 tw-flex-grow" }, " Create and manage dynamic PDF templates. Drag and drop data fields onto your dispatch sheets and BOLs. ", -1)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDocBuilder())),
            class: "tw-mt-6 tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-bg-slate-50 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-transition hover:tw-bg-slate-100"
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "chart-simple",
              class: "tw-h-3.5 tw-w-3.5"
            }),
            _cache[18] || (_cache[18] = _createTextVNode(" Manage Templates ", -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      isOpen: _ctx.isModalOpen,
      "onUpdate:isOpen": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isModalOpen) = $event)),
      modalId: "reports-generate-modal",
      maxWidth: "md"
    }, {
      title: _withCtx(() => [
        _createTextVNode("Generate " + _toDisplayString(_ctx.activeReportName), 1)
      ]),
      subtitle: _withCtx(() => [...(_cache[22] || (_cache[22] = [
        _createTextVNode("Fill in the information below to generate your report", -1)
      ]))]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.reportType !== 'ORDER')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Date Range", -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "tw-mb-1 tw-block tw-text-[10px] tw-font-bold tw-uppercase tw-text-slate-400" }, "From", -1)),
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.dateStart,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateStart) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.dateStart)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.formErrors.dateStart), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "tw-mb-1 tw-block tw-text-[10px] tw-font-bold tw-uppercase tw-text-slate-400" }, "To", -1)),
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.dateEnd,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateEnd) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.dateEnd)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.formErrors.dateEnd), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.formErrors.dateRange)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.formErrors.dateRange), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.reportType === 'MOVES')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_InputField, {
                      modelValue: _ctx.driverId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.driverId) = $event)),
                      label: "Driver ID",
                      type: "number",
                      placeholder: "ID"
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.driverId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.formErrors.driverId), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_InputField, {
                      modelValue: _ctx.chassis,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chassis) = $event)),
                      label: "Chassis Number",
                      placeholder: "Chassis #"
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.chassis)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.formErrors.chassis), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_InputField, {
                      modelValue: _ctx.originId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.originId) = $event)),
                      label: "Origin ID",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.originId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.formErrors.originId), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_InputField, {
                      modelValue: _ctx.destinationId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.destinationId) = $event)),
                      label: "Destination ID",
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    (_ctx.formErrors.destinationId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.formErrors.destinationId), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_DropdownList, {
                  modelValue: _ctx.weekStartDay,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.weekStartDay) = $event)),
                  options: ['MONDAY', 'SATURDAY'],
                  label: "Week Starts On"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.reportType === 'ORDER' || _ctx.reportType === 'MOVES')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_InputField, {
                  modelValue: _ctx.orderId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.orderId) = $event)),
                  label: "Booking / Reference Number",
                  placeholder: "e.g. EBKG12345678"
                }, null, 8, ["modelValue"]),
                (_ctx.formErrors.orderId)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.formErrors.orderId), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.reportType === 'DRIVERS_TRIPS')
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("button", {
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-px-3 tw-py-2", [_ctx.driversTripsDateMode === 'EXACT_DATES' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-slate-100 tw-text-slate-400']]),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.driversTripsDateMode = 'EXACT_DATES'))
                }, "Exact Dates", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-px-3 tw-py-2", [_ctx.driversTripsDateMode === 'WEEKS' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-slate-100 tw-text-slate-400']]),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.driversTripsDateMode = 'WEEKS'))
                }, "Weeks", 2),
                _createElementVNode("label", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.driversTripsByDriversSwitch) = $event)),
                    class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.driversTripsByDriversSwitch]
                  ]),
                  _cache[26] || (_cache[26] = _createTextVNode(" print by driver ", -1))
                ]),
                (_ctx.driversTripsDateMode === 'WEEKS')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createVNode(_component_FilterableDropdown, {
                        modelValue: _ctx.driversTripsWeekSelected,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.driversTripsWeekSelected) = $event)),
                        class: "tw-w-full tw-min-w-0",
                        options: _ctx.weekOptions,
                        label: "formatted",
                        inPill: true,
                        onInput: _cache[13] || (_cache[13] = (week) => { const vm = this as any; vm.dateStart = week.start; vm.dateEnd = week.end})
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.reportType === 'TRACKING')
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_DropdownList, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.status) = $event)),
                  label: "Filter by Status",
                  options: ['All', 'Onboard Vessel', 'Available', 'Not available', 'Off-Dock']
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "tw-mb-3 tw-block tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400" }, " Export as ", -1)),
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList((['PDF', 'XLSX', 'CSV'] as const), (fmt) => {
                return _createElementVNode("button", {
                  key: fmt,
                  onClick: ($event: any) => (_ctx.selectedFormat = fmt),
                  class: _normalizeClass([
              'tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-py-3 tw-text-sm tw-font-bold tw-transition',
              _ctx.selectedFormat === fmt
                ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white'
                : 'tw-border-slate-200 tw-bg-white tw-text-slate-600 hover:tw-border-slate-300'
            ])
                }, _toDisplayString(fmt), 11, _hoisted_42)
              }), 64))
            ])
          ]),
          _createVNode(_component_Button, {
            onClick: _ctx.handleGenerate,
            loading: _ctx.loading,
            class: "tw-w-full tw-rounded-xl tw-bg-slate-900 tw-py-4 tw-text-white hover:tw-bg-slate-800 tw-flex tw-items-center tw-justify-center tw-gap-3"
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "circle-notch",
                    spin: ""
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "download"
                  })),
              _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Generating...' : 'Generate & Download'), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    (_ctx.isDocBuilderOpen)
      ? (_openBlock(), _createBlock(_component_DocumentTemplateEditor, {
          key: 0,
          "is-open": _ctx.isDocBuilderOpen,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isDocBuilderOpen = false))
        }, null, 8, ["is-open"]))
      : _createCommentVNode("", true)
  ]))
}